// How often (ms) to send a ping frame to the server to keep the connection alive
export const HEARTBEAT_INTERVAL = 30_000;

// How long (ms) to wait for a pong response before treating the connection as dead and force-closing it
export const HEARTBEAT_TIMEOUT = 10_000;

// Maximum number of consecutive reconnect attempts before giving up and marking the connection as failed
export const MAX_WS_RECONNECT_ATTEMPTS = 5;

// Base delay (ms) between reconnect attempts — used as the starting point for exponential backoff
export const RECONNECT_DELAY = 5000;
